import React from "react";
import styled from "styled-components";
import googleIcon from "../assets/images/google-icon.svg";
import Logo from "../components/Logo";

const SignInPage: React.FC = () => {
  return (
    <SignInContainer>
      <Oval />
      <Header>
        <LogoContainer>
          <Logo />
          <AppName>Ortix Glow</AppName>
        </LogoContainer>
      </Header>
      <ContentWrapper>
        <LeftColumn>
          <WelcomeText>
            Hello there!
            <br />
            I&apos;ll help you build a new Chatbot.
            <br />
            What would you like to create?
          </WelcomeText>
        </LeftColumn>
        <RightColumn>
          <SignInCard>
            <Title>Sign In</Title>
            <Subtitle>Start your 30 day free trial!!!!!</Subtitle>
            <Divider />
            <GoogleButton>
              <GoogleIconImg src={googleIcon} alt="Google" />
              <span>Google</span>
            </GoogleButton>
            <SignInInfo>
              <AlreadyHaveAccount>Already have an account?</AlreadyHaveAccount>
              <SignInLink>Sign in</SignInLink>
            </SignInInfo>
          </SignInCard>
        </RightColumn>
      </ContentWrapper>
    </SignInContainer>
  );
};

const SignInContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #e4fffb;
  position: relative;
  padding: 1.5rem 2rem;
`;

const Header = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  gap: 2rem;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-right: 2rem;
  @media (max-width: 768px) {
    padding-right: 0;
    align-items: center;
    text-align: center;
    margin-bottom: 2rem;
  }
`;

const RightColumn = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Oval = styled.div`
  position: absolute;
  top: 50px;
  right: 50px;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-color: rgba(0, 146, 127, 0.3);
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const AppName = styled.h1`
  font-family: "Albert Sans", sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #171a1f;
  margin: 0;
`;

const WelcomeText = styled.h2`
  font-family: "Albert Sans", sans-serif;
  font-weight: 700;
  font-size: 32px;
  color: #00927f;
  line-height: 1.5em;
  max-width: 600px;
  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const SignInCard = styled.div`
  background-color: #ffffff;
  border-radius: 24px;
  padding: 2.5rem;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow:
    0px 4px 9px 0px rgba(23, 26, 31, 0.19),
    0px 0px 2px 0px rgba(23, 26, 31, 0.2);
  border: 1px solid #00927f;
`;

const Title = styled.h2`
  font-family: "Albert Sans", sans-serif;
  font-weight: 700;
  font-size: 32px;
  color: #171a1f;
  margin: 0 0 0.5rem 0;
  text-align: center;
`;

const Subtitle = styled.p`
  font-family: "actor", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #9095a0;
  margin: 0 0 1.5rem 0;
  text-align: center;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f3f4f6;
  margin: 1.5rem 0;
`;

const GoogleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1rem;
  background-color: #00927f;
  border: none;
  border-radius: 12px;
  color: #ffffff;
  font-family: "Actor", sans-serif;
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;
  margin-bottom: 1.5rem;
  gap: 10px;
  &:hover {
    opacity: 0.9;
  }
`;

const GoogleIconImg = styled.img`
  width: 24px;
  height: 24px;
`;

const SignInInfo = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const AlreadyHaveAccount = styled.p`
  font-family: "Actor", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #171a1f;
  margin: 0;
`;

const SignInLink = styled.a`
  font-family: "Actor", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #00927f;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export default SignInPage;
